import { ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';

interface TabProps extends ComponentPropsWithoutRef<'button'> {
  active?: boolean;
}

const Tab = ({ className, active, ...props }: TabProps) => (
  <button
    type="button"
    className={
      classNames(
        '!rounded-none px-6 py-5 font-semibold align-middle relative text-secondary-500',
        'disabled:cursor-not-allowed disabled:text-secondary-300',
        {
          'text-secondary-900 after:right-0 after:h-0.5 after:absolute after:bottom-0 after:left-0 after:mx-2 after:rounded-t after:bg-secondary-900': active,
        },
        className,
      )
    }
    {...props}
  />
);

export default Tab;
